import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  AbstractControl,
  ControlContainer,
  FormArray, FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule
} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {InputsModule, SliderModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {Assessment, AssessmentDomain} from '../../models/models.lib';
import {LoggerService} from '../../shared/logger.service';
import _ from 'lodash';
import {distinctUntilChanged, Subject, Subscription, takeUntil} from 'rxjs';
import {HelpButtonComponent} from '../../admin/help-info/help-button/help-button.component';
import {HelpPopoverComponent} from '../../admin/help-info/help-popover/help-popover.component';

@Component({
  selector: 'casi-assessment-domain',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    SliderModule,
    HelpPopoverComponent,
    HelpButtonComponent
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: true,
  templateUrl: './assessment-domain.component.html',
  styleUrl: './assessment-domain.component.scss'
})
export class AssessmentDomainComponent   implements OnInit {

  @Input({ required: true }) domainForm!: FormGroup;
  @Input({ required: true }) assessmentForm!: FormGroup;
  @Output() optOutChanged = new EventEmitter<boolean>();

  private sub?: Subscription;
  public averageScore: number = 0;
  // private optOutSub?: Subscription;

  constructor(
    private logger: LoggerService,
    private fb: FormBuilder
  ) {}

  get optOut(): FormControl {
    return this.domainForm.get('opt_out') as FormControl;
  }

  get comment(): FormControl {
    return this.domainForm.get('comment') as FormControl;
  }

  get domain_answers(): FormArray<FormGroup> {
    return this.domainForm.get('domain_answers') as FormArray<FormGroup>;
  }

  getAnswerControl(q: FormGroup, name: string): FormControl {
    return q.get(name) as FormControl;
  }

  get scaleArray(): FormArray {
    return (this.assessmentForm.get('rating_scale') as FormArray)
      ?? this.fb.array([]);
  }

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.sub = this.domainForm.valueChanges.subscribe(() => {
      this.updateAverageScore();
    });
    this.updateAverageScore();

    // this.optOutSub = this.optOut.valueChanges
    //   .subscribe((checked: boolean) => {
    //   this.domain_answers.controls.forEach((group: AbstractControl) => {
    //     const valueControl = group.get('value');
    //     if (checked)
    //       valueControl?.disable();
    //     else
    //       valueControl?.enable();
    //
    //     this.optOutChanged.emit(checked);
    //   });
    // });

  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    // this.optOutSub?.unsubscribe();
  }

  public onOptOutChange(checked: boolean) {
    this.optOut.setValue(checked, { emitEvent: false });

    this.domain_answers.controls.forEach((group: AbstractControl) => {
      const ctrl = group.get('value');

      if (this.domainForm.disabled) {
        return;
      }

      if (checked) {
        ctrl?.disable();
      } else {
        ctrl?.enable();
      }
    });

    this.optOutChanged.emit(checked);
  }

  getMinScaleValue(): number {
    const scaleArray = this.assessmentForm.get('rating_scale') as FormArray;
    const values = scaleArray?.value ?? [];

    if (!values.length) return 1;
    return Math.min(...values.map((s: any) => Number(s.rating_scale_value)));
  }

  getMaxScaleValue(): number {
    const scaleArray = this.assessmentForm.get('rating_scale') as FormArray;
    const values = scaleArray?.value ?? [];

    if (!values.length) return 7;

    return Math.max(...values.map((s: any) => Number(s.rating_scale_value)));
  }

  private updateAverageScore(): void {
    const answers = this.domain_answers;

    if (!answers || answers.length === 0) {
      this.averageScore = 0;
      return;
    }

    const total = answers.controls.reduce((sum, control) => {
      const value = Number(control.get('value')?.value) || 0;
      return sum + value;
    }, 0);

    this.averageScore = Number((total / answers.length).toFixed(2));
  }

}
